// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"477":"53f4f1aa","665":"ba81259f"}[chunkId] + ".css";
};